// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Primary colors */
    --color-primary-white: #FFFFFF;
    --color-primary-bg-lightcream:#fffefa;
    /* --color-primary-sidebar-bg-blue: #0078d4; "The over-used blue" */
    --color-primary-sidebar-bg-blue: #0067b5;
    --color-primary-accents-orange: #F59E0B;
    --color-primary-text-darkblue: #1E3A8A;

    /* Supporting colors */
    --color-sup-smalltext-gray: #6B7280;
    --color-sup-hover-lightblue: #bedaff;
    --color-sup-bg-cream: #FDF6E3;
    --color-sup-check-green: #10B981;
}

body {
    background-color: var(--color-sup-bg-cream);
    color: var(--color-primary-text-darkblue);
}
div.main-wrapper {
    display: grid;
    grid-template-columns: minmax(250px, 300px) minmax(360px, 100%);
    grid-template-rows: minmax(100vh, 100%);
    gap: 10px;
}

/* Sidebar styles */
.sidebar-wrapper {
    border-right: 8px solid var(--color-primary-accents-orange);
    background-color: var(--color-primary-sidebar-bg-blue);
    color: var(--color-primary-white);
    padding-left: 10px;
    padding-top: 20px;
    font-size: 1.2rem;
}
.sidebar-header button.sidebar-action {
    font-weight: 700;
    font-size: 1.6rem;
    background: none;
    letter-spacing: 2px;
}
.sidebar-header {
    display: flex;
}
img.site-logo {
    width: 35px;
}
ul.nav-main-list, ul.nav-sub-list {
    list-style: none;
    margin-left: 0;
    padding-left: 0; 
}
#site-title:hover {
    translate: 0;
    background-color: inherit;
}
.sidebar-nav {
    display: flex;
    gap: 10px;
    flex-direction: column;
}
.nav-main-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.nav-sub-list {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    gap: 5px;
}
.nav-sub-item {
    padding-left: 18px;
}
.nav-sub-item#sidebar-create-new-project {
    padding-left: 9px;
}
button.sidebar-action {
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    padding: 0 6px 4px 6px;
    color: inherit;
    letter-spacing: 1px;
}
button.sidebar-action:hover {
    translate: 2px;
    background-color: var(--color-primary-accents-orange);
    border-radius: 8px;
}

/* Card styles */
.main-content {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-top: 15px;
    letter-spacing: 1px;
}
@keyframes fadeIn {
    from { opacity: 0.5; }
    to { opacity: 1; }
}
.card-container {
    background-color: var(--color-primary-white);
    height: max-content;
    min-width: 200px;
    max-width: 360px;
    border-radius: 6px;
    padding: 0 15px;
    border-left: 2px solid var(--color-primary-accents-orange);
    box-shadow: 1px 2px 3px rgba(197, 127, 8, 0.2);
    /* cursor: grab; */
    animation: fadeIn 300ms ease-in forwards; /* The animation is triggered when card-container is created. */
}
/* .card-container:active {
    cursor: grabbing;
} */
div.card-project-title-container {
    display: grid;
    grid-template-columns: 1fr 2rem;
    gap: 0.8rem;
}
.card-project-title-container:hover .card-actions-container {
    opacity: 0.8;
}
div.card-project-title-container .card-actions-container {
    margin-top: 12px;
}
h3.card-project-title {
    margin-top: 12px;
    margin-bottom: 0;
    padding-bottom: 0;
    letter-spacing: 2px;
    font-weight: 500;
}
ul.card-task-list {
    display: grid;
    grid-template-columns: 0.8rem 1fr 4rem;
    gap: 10px;
    padding-left: 6px;
}
.card-task-item {
    display: grid;
    grid-column: span 3;
    grid-template-columns: 0.8rem 1fr 4rem;
    gap: 0.8rem;
    font-weight: 400;
    animation: fadeIn 400ms ease-in forwards;
    align-items: start;
}

.card-task-item input[type="checkbox"]:checked + details{
    color: green;
    text-decoration: line-through;
}
.card-task-item input[type="checkbox"] {
    accent-color: green;
    margin-top: 3px;
}
details .expanded-details-container {
    display: grid;
    font-size: 0.8rem;
    /* padding-left: 0.5rem; */
}
.priority {
    border-radius: 10px;
    width: fit-content;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 3px;
    padding-top: 2px;
    text-wrap: nowrap;
}
/* Priority colors */
[data-priority='low'] {
    background-color: var(--color-sup-hover-lightblue);
}
[data-priority='medium'] {
    background-color: yellow
}
[data-priority='high'] {
    background-color: red;
    color: black;
}
.card-task-item.add-new-task {
    text-wrap: nowrap;
    cursor: pointer;
    border-radius: 20px;
    background-color: rgba(68, 67, 66, 0.1);
    width:8.5rem;
    padding-left: 0.4rem;
    padding-top: 0.1rem;
    padding-bottom: 0.15rem;
    transition: box-shadow 250ms ease;
}
.card-task-item.add-new-task:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    background-color: rgba(68, 67, 66, 0.2);
}
.card-task-item.add-new-task:active {
    box-shadow: none;
    background-color: rgba(68, 67, 66, 0.3);
    transform: translateY(1px);
}
.card-actions-container {
    display: flex;
    justify-content: space-between;
    opacity: 0;
    transition: opacity 200ms ease;
}
.card-actions-container img {
    cursor: pointer;
}
.card-task-item:hover .card-actions-container {
    opacity: 0.8;
}
.card-task-item details summary {
    pointer-events: none;
}
a {
    text-decoration: none;
}

/* Remove default <details> arrow in both chrome and firefox */
details > summary:first-of-type {
    list-style-type: none;
}
details summary::-webkit-details-marker {
    display: none;
}

/* Form styles */
dialog {
    border: none;
    border-left: 3px solid var(--color-primary-accents-orange);
    border-right: 3px solid var(--color-primary-accents-orange);
    border-radius: 30px;
    box-shadow: 1px 1px 5px var(--color-sup-smalltext-gray);
    min-width: 350px;
}
form {
    display: grid;
    gap: 1rem;
    border-color: var(--color-primary-accents-orange);
} 
form textarea#details-card-task {
    height: 3rem;
}
form button {
    justify-self: center;
    background-color: var(--color-primary-sidebar-bg-blue);
    color: var(--color-primary-bg-lightcream);
    padding: 0.5rem;
    border-radius: 20px;
    border: none;
    width: 8rem;
}
form button:active {
    transform: translateY(1px);
    box-shadow: 0 -3px 4px -3px var(--color-sup-smalltext-gray);
}
form div {
    grid-column: span 2;
}
form button#submitButton {
    grid-column: 1 / 2;
}
form button#cancelButton {
    grid-column: 2 / 3;
}
form div input[name="title"],
form div textarea[name="details"] {
    min-width: 300px;
}
button.confirm-delete {
    background-color: #780606;
    color: var(--color-primary-bg-lightcream);
    border-radius: 10px;
    border: 2px solid black;
    width: 5rem;
}
button.cancel {
    background-color: var(--color-primary-sidebar-bg-blue);
    color: var(--color-primary-bg-lightcream);
    padding: 0.5rem;
    border-radius: 20px;
    border: none;
    width: 6rem;
}
dialog>p {
    margin-top: 0;
    font-weight: 600;
    font-size: 1.2rem;
    text-align: center;
}
dialog#dialog-confirm-delete:modal {
    min-width: 200px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
    gap: 1rem;
}
dialog#dialog-confirm-delete p {
    grid-column: span 2;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,qCAAqC;IACrC,mEAAmE;IACnE,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;;IAEtC,sBAAsB;IACtB,mCAAmC;IACnC,oCAAoC;IACpC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,+DAA+D;IAC/D,uCAAuC;IACvC,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,2DAA2D;IAC3D,sDAAsD;IACtD,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,OAAO,YAAY,EAAE;IACrB,KAAK,UAAU,EAAE;AACrB;AACA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,0DAA0D;IAC1D,8CAA8C;IAC9C,kBAAkB;IAClB,wCAAwC,EAAE,+DAA+D;AAC7G;AACA;;GAEG;AACH;IACI,aAAa;IACb,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,oBAAoB;AACpB;IACI,kDAAkD;AACtD;AACA;IACI;AACJ;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,sCAAsC;IACtC,uCAAuC;AAC3C;AACA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;;AAEA,8DAA8D;AAC9D;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,0DAA0D;IAC1D,2DAA2D;IAC3D,mBAAmB;IACnB,uDAAuD;IACvD,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,iDAAiD;AACrD;AACA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,sDAAsD;IACtD,yCAAyC;IACzC,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,2DAA2D;AAC/D;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,sDAAsD;IACtD,yCAAyC;IACzC,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,mBAAmB;AACvB","sourcesContent":[":root {\r\n    /* Primary colors */\r\n    --color-primary-white: #FFFFFF;\r\n    --color-primary-bg-lightcream:#fffefa;\r\n    /* --color-primary-sidebar-bg-blue: #0078d4; \"The over-used blue\" */\r\n    --color-primary-sidebar-bg-blue: #0067b5;\r\n    --color-primary-accents-orange: #F59E0B;\r\n    --color-primary-text-darkblue: #1E3A8A;\r\n\r\n    /* Supporting colors */\r\n    --color-sup-smalltext-gray: #6B7280;\r\n    --color-sup-hover-lightblue: #bedaff;\r\n    --color-sup-bg-cream: #FDF6E3;\r\n    --color-sup-check-green: #10B981;\r\n}\r\n\r\nbody {\r\n    background-color: var(--color-sup-bg-cream);\r\n    color: var(--color-primary-text-darkblue);\r\n}\r\ndiv.main-wrapper {\r\n    display: grid;\r\n    grid-template-columns: minmax(250px, 300px) minmax(360px, 100%);\r\n    grid-template-rows: minmax(100vh, 100%);\r\n    gap: 10px;\r\n}\r\n\r\n/* Sidebar styles */\r\n.sidebar-wrapper {\r\n    border-right: 8px solid var(--color-primary-accents-orange);\r\n    background-color: var(--color-primary-sidebar-bg-blue);\r\n    color: var(--color-primary-white);\r\n    padding-left: 10px;\r\n    padding-top: 20px;\r\n    font-size: 1.2rem;\r\n}\r\n.sidebar-header button.sidebar-action {\r\n    font-weight: 700;\r\n    font-size: 1.6rem;\r\n    background: none;\r\n    letter-spacing: 2px;\r\n}\r\n.sidebar-header {\r\n    display: flex;\r\n}\r\nimg.site-logo {\r\n    width: 35px;\r\n}\r\nul.nav-main-list, ul.nav-sub-list {\r\n    list-style: none;\r\n    margin-left: 0;\r\n    padding-left: 0; \r\n}\r\n#site-title:hover {\r\n    translate: 0;\r\n    background-color: inherit;\r\n}\r\n.sidebar-nav {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-direction: column;\r\n}\r\n.nav-main-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n.nav-sub-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 5px;\r\n    gap: 5px;\r\n}\r\n.nav-sub-item {\r\n    padding-left: 18px;\r\n}\r\n.nav-sub-item#sidebar-create-new-project {\r\n    padding-left: 9px;\r\n}\r\nbutton.sidebar-action {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    padding: 0 6px 4px 6px;\r\n    color: inherit;\r\n    letter-spacing: 1px;\r\n}\r\nbutton.sidebar-action:hover {\r\n    translate: 2px;\r\n    background-color: var(--color-primary-accents-orange);\r\n    border-radius: 8px;\r\n}\r\n\r\n/* Card styles */\r\n.main-content {\r\n    display: flex;\r\n    gap: 15px;\r\n    flex-wrap: wrap;\r\n    align-content: flex-start;\r\n    padding-top: 15px;\r\n    letter-spacing: 1px;\r\n}\r\n@keyframes fadeIn {\r\n    from { opacity: 0.5; }\r\n    to { opacity: 1; }\r\n}\r\n.card-container {\r\n    background-color: var(--color-primary-white);\r\n    height: max-content;\r\n    min-width: 200px;\r\n    max-width: 360px;\r\n    border-radius: 6px;\r\n    padding: 0 15px;\r\n    border-left: 2px solid var(--color-primary-accents-orange);\r\n    box-shadow: 1px 2px 3px rgba(197, 127, 8, 0.2);\r\n    /* cursor: grab; */\r\n    animation: fadeIn 300ms ease-in forwards; /* The animation is triggered when card-container is created. */\r\n}\r\n/* .card-container:active {\r\n    cursor: grabbing;\r\n} */\r\ndiv.card-project-title-container {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2rem;\r\n    gap: 0.8rem;\r\n}\r\n.card-project-title-container:hover .card-actions-container {\r\n    opacity: 0.8;\r\n}\r\ndiv.card-project-title-container .card-actions-container {\r\n    margin-top: 12px;\r\n}\r\nh3.card-project-title {\r\n    margin-top: 12px;\r\n    margin-bottom: 0;\r\n    padding-bottom: 0;\r\n    letter-spacing: 2px;\r\n    font-weight: 500;\r\n}\r\nul.card-task-list {\r\n    display: grid;\r\n    grid-template-columns: 0.8rem 1fr 4rem;\r\n    gap: 10px;\r\n    padding-left: 6px;\r\n}\r\n.card-task-item {\r\n    display: grid;\r\n    grid-column: span 3;\r\n    grid-template-columns: 0.8rem 1fr 4rem;\r\n    gap: 0.8rem;\r\n    font-weight: 400;\r\n    animation: fadeIn 400ms ease-in forwards;\r\n    align-items: start;\r\n}\r\n\r\n.card-task-item input[type=\"checkbox\"]:checked + details{\r\n    color: green;\r\n    text-decoration: line-through;\r\n}\r\n.card-task-item input[type=\"checkbox\"] {\r\n    accent-color: green;\r\n    margin-top: 3px;\r\n}\r\ndetails .expanded-details-container {\r\n    display: grid;\r\n    font-size: 0.8rem;\r\n    /* padding-left: 0.5rem; */\r\n}\r\n.priority {\r\n    border-radius: 10px;\r\n    width: fit-content;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    padding-bottom: 3px;\r\n    padding-top: 2px;\r\n    text-wrap: nowrap;\r\n}\r\n/* Priority colors */\r\n[data-priority='low'] {\r\n    background-color: var(--color-sup-hover-lightblue);\r\n}\r\n[data-priority='medium'] {\r\n    background-color: yellow\r\n}\r\n[data-priority='high'] {\r\n    background-color: red;\r\n    color: black;\r\n}\r\n.card-task-item.add-new-task {\r\n    text-wrap: nowrap;\r\n    cursor: pointer;\r\n    border-radius: 20px;\r\n    background-color: rgba(68, 67, 66, 0.1);\r\n    width:8.5rem;\r\n    padding-left: 0.4rem;\r\n    padding-top: 0.1rem;\r\n    padding-bottom: 0.15rem;\r\n    transition: box-shadow 250ms ease;\r\n}\r\n.card-task-item.add-new-task:hover {\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\r\n    background-color: rgba(68, 67, 66, 0.2);\r\n}\r\n.card-task-item.add-new-task:active {\r\n    box-shadow: none;\r\n    background-color: rgba(68, 67, 66, 0.3);\r\n    transform: translateY(1px);\r\n}\r\n.card-actions-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    opacity: 0;\r\n    transition: opacity 200ms ease;\r\n}\r\n.card-actions-container img {\r\n    cursor: pointer;\r\n}\r\n.card-task-item:hover .card-actions-container {\r\n    opacity: 0.8;\r\n}\r\n.card-task-item details summary {\r\n    pointer-events: none;\r\n}\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n/* Remove default <details> arrow in both chrome and firefox */\r\ndetails > summary:first-of-type {\r\n    list-style-type: none;\r\n}\r\ndetails summary::-webkit-details-marker {\r\n    display: none;\r\n}\r\n\r\n/* Form styles */\r\ndialog {\r\n    border: none;\r\n    border-left: 3px solid var(--color-primary-accents-orange);\r\n    border-right: 3px solid var(--color-primary-accents-orange);\r\n    border-radius: 30px;\r\n    box-shadow: 1px 1px 5px var(--color-sup-smalltext-gray);\r\n    min-width: 350px;\r\n}\r\nform {\r\n    display: grid;\r\n    gap: 1rem;\r\n    border-color: var(--color-primary-accents-orange);\r\n} \r\nform textarea#details-card-task {\r\n    height: 3rem;\r\n}\r\nform button {\r\n    justify-self: center;\r\n    background-color: var(--color-primary-sidebar-bg-blue);\r\n    color: var(--color-primary-bg-lightcream);\r\n    padding: 0.5rem;\r\n    border-radius: 20px;\r\n    border: none;\r\n    width: 8rem;\r\n}\r\nform button:active {\r\n    transform: translateY(1px);\r\n    box-shadow: 0 -3px 4px -3px var(--color-sup-smalltext-gray);\r\n}\r\nform div {\r\n    grid-column: span 2;\r\n}\r\nform button#submitButton {\r\n    grid-column: 1 / 2;\r\n}\r\nform button#cancelButton {\r\n    grid-column: 2 / 3;\r\n}\r\nform div input[name=\"title\"],\r\nform div textarea[name=\"details\"] {\r\n    min-width: 300px;\r\n}\r\nbutton.confirm-delete {\r\n    background-color: #780606;\r\n    color: var(--color-primary-bg-lightcream);\r\n    border-radius: 10px;\r\n    border: 2px solid black;\r\n    width: 5rem;\r\n}\r\nbutton.cancel {\r\n    background-color: var(--color-primary-sidebar-bg-blue);\r\n    color: var(--color-primary-bg-lightcream);\r\n    padding: 0.5rem;\r\n    border-radius: 20px;\r\n    border: none;\r\n    width: 6rem;\r\n}\r\ndialog>p {\r\n    margin-top: 0;\r\n    font-weight: 600;\r\n    font-size: 1.2rem;\r\n    text-align: center;\r\n}\r\ndialog#dialog-confirm-delete:modal {\r\n    min-width: 200px;\r\n    display: grid;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-items: center;\r\n    gap: 1rem;\r\n}\r\ndialog#dialog-confirm-delete p {\r\n    grid-column: span 2;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
